import React from 'react';

function Modal({ open, children }) {
  if (!open) return null;
  return;
  <div>Infinite Pomodoro Timer. Like no other.</div>;
}

export default Modal;
